import {FormEventHandler, forwardRef, ReactNode, useEffect} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import {posthogTrack} from 'src/utils'
import {useAuthStore, usePayStubStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsPayStubEarningsStatementNew.module.scss'
import PayStubItemNew from './PayStubItemNew'

const cx = cn.bind(s)

interface IFieldsPayStubEarningsStatementNewProps {
	className?: string
	children?: ReactNode | string
	onChange?: FormEventHandler<HTMLDivElement>
}

const FieldsPayStubEarningsStatementNew = forwardRef<
	HTMLDivElement,
	IFieldsPayStubEarningsStatementNewProps
>(({className, children, ...props}, ref) => {
	const payStubStore = usePayStubStore()
	const {items} = payStubStore
	const authStore = useAuthStore()

	useEffect(() => {
		if (!authStore.hasActiveSubscription) {
			posthogTrack(`[PAYSTUB unsubscribed] Step 5 started`)
		}
	}, [authStore.hasActiveSubscription])

	useEffect(() => {
		posthogTrack(`[PAYSTUB] Step 5 started`)
	}, [])

	useEffect(() => {
		payStubStore.calculateItems()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className={cx('stub', className)} {...props} ref={ref}>
			{children}

			{items.map((_, index) => (
				<PayStubItemNew key={index} index={index} />
			))}
		</div>
	)
})

FieldsPayStubEarningsStatementNew.displayName = 'FieldsPayStubEarningsStatementNew'

export default observer(FieldsPayStubEarningsStatementNew)
